import { createContext, useContext } from 'react'
import { newTile, OverviewTile } from './defaults'

export interface OverviewContextType {
  isCustomizing: boolean
  isPending: boolean
  onEditTile: (tile: OverviewTile, index: number) => void
}

export const OverviewContext = createContext<OverviewContextType>({
  isCustomizing: false,
  isPending: false,
  onEditTile: () => undefined,
})

export const useOverviewEditorState = () => {
  const context = useContext(OverviewContext)
  if (context === undefined) {
    throw new Error('useOverviewState must be used within a OverviewProvider')
  }

  return context
}

export interface TileContextType {
  tile: OverviewTile
  index: number
}

export const TileContext = createContext<TileContextType>({
  tile: newTile,
  index: 0,
})

export const useTile = () => {
  const context = useContext(TileContext)
  if (context === undefined) {
    throw new Error('useTile must be used within a TileProvider')
  }

  return context
}
